import emptySearch from 'assets/images/empty-search.svg';

const OrdersEmptyState: React.FC = () => {
  return (
    <div className="flex min-h-60 flex-col items-center justify-center gap-2.5 text-center">
      <img src={emptySearch} alt="" />
      <span className="text-subtitle-md text-gray-09">نتیجه‌ای یافت نشد!</span>
      <span className="text-body-md-emphasis text-gray-07">سفارشی با این مشخصات ندارید.</span>
    </div>
  );
};

export default OrdersEmptyState;
